import { render, staticRenderFns } from "./sideMenu.vue?vue&type=template&id=a3af5000"
import script from "./sideMenu.vue?vue&type=script&lang=js"
export * from "./sideMenu.vue?vue&type=script&lang=js"
import style0 from "./sideMenu.vue?vue&type=style&index=0&id=a3af5000&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports